import React from "react";
import {connect} from "src/store";
import TillBasedContext from "../Till/TillBasedContext";
import PosBasedContext from "../Pos/PosBasedContext";

export type needle = string|string[];

type Props = {
    context?: {
        till?: {
            pos?: {
                id?: number|string|null
            }
        }
    }
    needle: needle,
};

class ContextBased extends React.Component<Props, any> {

    render() {
        let needle = this.props.needle;
        if (!needle) {
            needle = [];
        }
        if (typeof needle === "string") {
            needle = [needle];
        }
        let children = this.props.children;
        if (needle.some((key) => key.indexOf("pos") !== -1)) {
            children = <PosBasedContext>
                {children}
            </PosBasedContext>
        }
        if (needle.some((key) => key.indexOf("till") !== -1)) {
            children = <TillBasedContext>
                {children}
            </TillBasedContext>
        }
        return children;
    }

}

export default connect((state) => {
    return {
        context: state.app.context
    };
}, {})(ContextBased);